/**
 * The single basemap behind every map on the storefront.
 *
 * ## Why this is not CARTO anymore
 *
 * The CARTO basemaps (`basemaps.cartocdn.com`, `light_all` here) started
 * painting "API KEY REQUIRED" and `carto.com/basemaps/apikey` diagonally INSIDE
 * the tile image. It is not a Leaflet overlay and not a load failure: the PNG
 * arrives with a 200 and is already stamped, so no client-side change removes
 * it, only a different source. The same breakage took down every map in
 * home-assistant/frontend (issue #53800, fixed in PR #53816, which also dropped
 * CARTO). Both storefront maps were on it: the merchant address preview and the
 * delivery-address picker, which is a checkout screen the customer sees.
 *
 * ## Keeping the look
 *
 * `light_all` was Positron, a washed-out grey base picked so the red pin is the
 * only saturated thing on screen. Plain OpenStreetMap is far more colourful, so
 * dropping it in raw would make the pin compete with the map. `MUTED_TILES_CLASS`
 * desaturates the tiles back down (see `globals.css`), which lands close to the
 * base these screens have always had.
 *
 * ## What the OSM tile policy asks for
 *
 * Visible attribution (hence `attribution`, which the CARTO layers were missing
 * even though CARTO required it too), no bulk downloading (Leaflet only fetches
 * what is on screen), and the plain `tile.openstreetmap.org` host: the policy
 * names it as the recommended one and warns that the `a/b/c` subdomains may be
 * slow or withdrawn. `{r}` is gone as well, that server serves no `@2x` and no
 * map here turns on `detectRetina`.
 */
export const MAP_TILE = {
  url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
} as const;

/**
 * Goes on the TILE LAYER, never on the map container: markers, the hint card
 * and the overlays must keep their own colours, and filtering the whole pane
 * would wash out the pin too.
 */
export const MUTED_TILES_CLASS = "map-tiles-muted";
